export default class UnsupportedSpecTypeError extends Error {
  assignmentId: string;
  specType: string | null | undefined;

  constructor(assignmentId: string, specType: string) {
    super(
      `Received assignment with unsupported spec type: "${specType}", assignmentId: ${assignmentId}`
    );
    this.assignmentId = assignmentId;
    this.specType = specType;
  }
}
